export default function DiamondIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="19"
      viewBox="0 0 24 19"
      fill="none"
    >
      <path
        d="M22.5 6.75L17.25 0.75H6.75L1.5 6.75M22.5 6.75L12 18M22.5 6.75H1.5M12 18L1.5 6.75M12 18L16.6023 6.75L12 0.75L7.39772 6.75L12 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
